// extracted by mini-css-extract-plugin
export default {"page":"RankMoreGame_page__Mj-cW","page_container":"RankMoreGame_page_container__z9sQb"};